import PropTypes from 'prop-types';

import SubscriptionOverviewV1 from './SubscriptionsV1';
import SubscriptionOverviewV2 from './SubscriptionsV2';

import { useSubscriptionV2 } from '../../utilities/helpers';

const SubscriptionOverview = ({ subscription }) => {
  const isV2Enabled = useSubscriptionV2();

  return (
    <>
      {isV2Enabled ? (
        <SubscriptionOverviewV2 subscription={subscription} />
      ) : (
        <SubscriptionOverviewV1 />
      )}
    </>
  );
};

SubscriptionOverview.propTypes = {
  subscription: PropTypes.object,
};

export default SubscriptionOverview;
